import { escape } from "./escape.js";
import { escapeRegExp } from "./escapeRegExp.js";
import { nbsp } from "./unicodes/nbsp.js";
import { wordjoiner } from "./unicodes/wordjoiner.js";

const formatStartSymbol = "[[";
const formatEndSymbol = "]]";

const formatTextReplacements = {
	// When adding a new format, do not forget to add a test for it in formatify.test.ts
	nl: "<br />",
	light: '<span class="font-light">$1</span>',
	semibold: '<span class="font-semibold">$1</span>',
	extrabold: '<span class="font-extrabold">$1</span>',
	orange: '<strong style="color:#C56D2E;">$1</strong>',
	green: '<span style="color:#5E7751;">$1</span>',
	small: "<small>$1</small>",
	bold: '<span class="font-bold">$1</span>',
	gray: '<span class="text-fcrgray">$1</span>',
	heading: '<h3 class="font-antipol text-fcrdarkgray font-medium text-5/tighter mt-4 mb-2">$1</h3>',
	p: "<p>$1</p>",
	"tb\\[(.*?)\\]": '<a class="underline" href="$1" target="_blank">$2</a>',
	"\\[(.*?)\\]": '<a class="underline" href="$1">$2</a>',
	uppercase: '<span class="uppercase">$1</span>',
	underline: "<u>$1</u>",
	q: "<q>$1</q>",
};

const escapedFormatStartSymbol = escapeRegExp(formatStartSymbol);
const escapedFormatEndSymbol = escapeRegExp(formatEndSymbol);

export function formatify(input: string | undefined): string {
	let result = input ?? "";
	result = result.normalize("NFC");
	result = result.replace(
		new RegExp(
			`(?<=(?:^|[^\\p{General_Category=Letter}])[\\p{General_Category=Letter}|&](?:${escapeRegExp(formatEndSymbol)})?) +|\\s(?=%)|(?<=\\d)\\s`,
			"gu",
		),
		nbsp,
	);
	result = result.replace(
		/(?<=\p{General_Category=Letter})-(?=\p{General_Category=Letter})(?![^[]*\]\[\[)/gu,
		`${wordjoiner}-${wordjoiner}`,
	);
	result = escape(result);

	for (const [start, replacement] of Object.entries(formatTextReplacements)) {
		result = result.replace(
			new RegExp(`${start}${escapedFormatStartSymbol}(.*?)${escapedFormatEndSymbol}`, "gu"),
			replacement,
		);
	}

	return result;
}
